import React from 'react'
import PropTypes from 'prop-types'

const ShareButton = (props) => (
  <a href={props.link} className="btn d-block" style={{ backgroundColor: props.color, margin: '0 1px' }} target="_blank">
    <img src={props.icon} height="16" alt="icon" />
  </a>
)

ShareButton.propTypes = {
  link: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
}

export default ShareButton



// WEBPACK FOOTER //
// ./client/components/ShareButton.js